import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import RewardForm from './RewardForm'

import { updateReward } from '../services'
import { handleError } from '../../../helpers'

export default function EditRewardModal({ visible, onClose, reward, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: reward
	})

	const onSubmit = values => {
		updateReward(reward.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(handleError)
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar premio</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<RewardForm 
						register={register}
						errors={errors}
						onlyEditable
					/>
					<Button color="primary" type="submit">
						Actualizar premio
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}